// お肉の種類で選ぶ
$(function () {
  $(".nav_collection_meat li > a").on("click", function () {
    $(this).next("ul").slideToggle().css("display", "flex");
  })
})

// ランキング
var galleryTop_t1 = new Swiper(".ranking_swiper", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 3,
    },
  },
});

// CPバナー
var galleryTop_t2 = new Swiper(".top_bnr", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesPerView: 1.2,
  autoplay: {
    delay: 5000,
  },
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 1.5,
    },
    1600: {
      slidesPerView: 2.3,
    },
  },
});

// 三原則カルーセル
var galleryTop_t3 = new Swiper(".slide_3gensoku_container", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesPerView: 1.2,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 20,
      //slidesPerView: 1.5,
      slidesPerView: 2.3,
      navigation: {
        nextEl: ".swiper-button-kodawari-next",
        prevEl: ".swiper-button-kodawari-prev",
      },
    },
  },
});

// チャートカルーセル
var galleryTop_chart = new Swiper(".slide_chart_container", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesPerView: 1.2,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 20,
      //slidesPerView: 1.5,
      slidesPerView: 2.3,
      navigation: {
        nextEl: ".swiper-button-chart-next",
        prevEl: ".swiper-button-chart-prev",
      },
    },
  },
});

// 肉の種類・ジャンルで選ぶ
$(function () {
  $(".products__sort .button").on("click", function () {
    $(".products__sort .button").removeClass("active");
    $(this).addClass("active");
  })
})
$(function () {
  var $grid = $(".list_menu").isotope({
    itemSelector: ".list_menu_item",
  });

  // store filter for each group
  var filters = {};

  $(".filters").on("click", ".button", function (event) {
    var $button = $(event.currentTarget);
    // get group key
    var $buttonGroup = $button.parents(".button-group");
    var filterGroup = $buttonGroup.attr("data-filter-group");
    // set filter for group
    filters[filterGroup] = $button.attr("data-filter");
    // combine filters
    var filterValue = concatValues(filters);
    // set filter for Isotope
    $grid.isotope({ filter: filterValue });
  });

  // change is-checked class on buttons
  $(".button-group").each(function (i, buttonGroup) {
    var $buttonGroup = $(buttonGroup);
    $buttonGroup.on("click", "button", function (event) {
      $buttonGroup.find(".is-checked").removeClass("is-checked");
      var $button = $(event.currentTarget);
      $button.addClass("is-checked");
    });
  });

  // flatten object by concatting values
  function concatValues(obj) {
    var value = "";
    for (var prop in obj) {
      value += obj[prop];
    }
    return value;
  }
});

$(function () {
  $(".card_shipping_price_area").on('change', function () {
    var now_id = ".card_shipping_price#" + $(this).parent("section").attr("id");
    $(".card_shipping_price" + now_id + " div").css("display", "none");
    var select_area = $(now_id + " .card_shipping_price_area option:selected").val();
    console.log("select_area:" + select_area);
    $(".card_shipping_price" + now_id + " " + select_area).css("display", "inline-block");
  });
});

/*
$(function () {
  $(".product-card .grid_title h3 a").each(function () {
    var item_name = $(this).text();
    var item_name_before = item_name.slice(0, item_name.indexOf("】") + 1);
    var item_name_after = item_name.slice(item_name.indexOf("】") + 1);
    var item_list_name = item_name_before + "<br>" + item_name_after;
    $(this).html(item_list_name);
  });
});

*/

// TOP new
// PC(768px以上):イノシシ(index1) / SP:十勝黒豚(index2) を先頭に表示
var fvInitialSlide = window.matchMedia("(min-width: 768px)").matches ? 1 : 2;
var galleryTop_fv = new Swiper(".top_fv_container", {
  initialSlide: fvInitialSlide,
  spaceBetween: 10,
  slidesPerView: 1.3,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 20,
      slidesPerView: 3,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-topbnr-next",
        prevEl: ".swiper-button-topbnr-prev",
      },
    },
  },
});

// ランキング
var galleryTop_t3 = new Swiper(".top_ranking_container", {
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerView: 1.5,
  loop: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 4,
      navigation: {
        nextEl: ".swiper-button-ranking-next",
        prevEl: ".swiper-button-ranking-prev",
      },
    },
  },
});

// ピックアップ
var galleryTop_pickup = new Swiper(".pickup_container", {
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerView: 1.5,
  loop: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 1.5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});

// top_fv_nav
var galleryTop_pickup = new Swiper(".top_fv_nav", {
  slidesPerView: 4,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-topfvnav-next",
    prevEl: ".swiper-button-topfvnav-prev",
  },
});

// TOP 特設ページ
var galleryTop_fv = new Swiper(".top_lp_container", {
  spaceBetween: 10,
  slidesPerView: 1.3,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 20,
      slidesPerView: 3,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-lp-next",
        prevEl: ".swiper-button-lp-prev",
      },
    },
  },
});

//FV下 種類で選ぶボタン
/*$(function () {
  $('').on('click', function () {

  })
})*/